import React from "react";

const Footer = () => {
  return (
    <footer className="bg-green-900 py-8 mt-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Contact Info */}
        <div>
          <h3 className="text-lg font-semibold mb-4 text-amber-100">
            Contact Us
          </h3>
          <p className="text-yellow-100">Email: setmnepal08@gmail.com</p>
          <p className="text-yellow-100">Phone: +977-9749830055</p>
          <p className="text-yellow-100">Address: Kupondole, Lalitpur, Nepal</p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-lg font-semibold mb-4 text-amber-100">
            Quick Links
          </h3>
          <ul className="space-y-2">
            <li>
              <a href="/about-us" className="hover:underline text-amber-100">
                About Us
              </a>
            </li>
            <li>
              <a href="/services" className="hover:underline text-amber-100">
                Services
              </a>
            </li>
            <li>
              <a href="/contact" className="hover:underline text-amber-100">
                Contact
              </a>
            </li>
          </ul>
        </div>

        {/* Social Media */}
        <div>
          <h3 className="text-lg font-semibold mb-4 text-amber-100">
            Follow Us
          </h3>
          <div className="flex space-x-4">
            {/* Facebook */}
            <a
              href="https://www.facebook.com/www.setmnepal.org.np/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className=" text-amber-100 hover:text-amber-700"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M22.675 0H1.325C.593 0 0 .594 0 1.326v21.348C0 23.406.593 24 1.325 24h11.49v-9.294H9.691v-3.622h3.124V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.466.099 2.798.143v3.24l-1.918.001c-1.504 0-1.796.715-1.796 1.764v2.313h3.588l-.467 3.622h-3.12V24h6.116C23.407 24 24 23.406 24 22.674V1.326C24 .594 23.407 0 22.675 0z" />
              </svg>
            </a>

            {/* LinkedIn */}
            <a
              href="https://linkedin.com/company/yourcompany"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="text-amber-100 hover:text-amber-700"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.024-3.037-1.85-3.037-1.851 0-2.135 1.445-2.135 2.939v5.667H9.358V9h3.414v1.561h.047c.476-.9 1.637-1.85 3.37-1.85 3.602 0 4.268 2.37 4.268 5.451v6.29zM5.337 7.433a2.07 2.07 0 11-.002-4.139 2.07 2.07 0 01.002 4.139zm1.777 13.019H3.56V9h3.554v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.727v20.545C0 23.227.792 24 1.771 24h20.451C23.204 24 24 23.227 24 22.273V1.727C24 .774 23.204 0 22.225 0z" />
              </svg>
            </a>
          </div>
        </div>
      </div>

      {/* Bottom copyright */}
      <div className="text-center mt-10 text-amber-100 text-sm">
        © {new Date().getFullYear()} SETM Nepal. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
